@if (mainFilename$ | async; as mainFilename) {
  <rs-vermietung-angebot
    *axLazyElement="'rs-vermietung-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></rs-vermietung-angebot>
}
